import CryptoJS from 'crypto-js';
import { useNavigate } from 'react-router';

export function userDataFromLocal() {
  const userData = localStorage.getItem('journey');
  if (userData !== null) {
    // const bytes = CryptoJS.AES.decrypt(userData, 'adminUserData');
    // console.log('userDataFromLocal', bytes);
    // const originalAdmiuserData = bytes.toString(CryptoJS.enc.Utf8);
    // console.log('originalAdmiuserData', JSON.parse(originalAdmiuserData));
    const parsedUserData = JSON.parse(userData);

    return parsedUserData;
  }
  return {};
}
